<div id="">
  <div class="">
    <div class="">
      <div class="d-flex flex-column" style="overflow: hidden; height: 100vh;">
        <div class="top text-white font-weight-bold">
          <img src="../assets/images/logo/revcollect-logo.png" alt="RideReg" style="max-width: 200px; width: 100%; object-fit: cover;" class="img-responsive logo">
        </div>
        <div class="card-wrapper " style=" height: 100vh; display: grid; grid-template-columns: 1fr 1fr; align-items: center; padding-left: 10px; padding-right: 10px;">
          <div class="card p-2" style="max-width: 430px; margin: auto;">
            <div class="header">
              <p class="lead">Login to your account</p>
            </div>
            <div class="body">
              <form class="form-auth-small" #loginForm="ngForm" (ngSubmit)="loginProcess()">
                <div class="form-group">
                  <label for="user_email" class="control-label sr-only">Username</label>
                  <!--[pattern]="EMAIL_VALIDATION"-->
                  <input type="text" class="form-control" autocomplete="username" placeholder="Username"
                         #user_email="ngModel" minlength="4"
                         id="user_email"
                         [(ngModel)]="credentials.email" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger" *ngIf="user_email.errors && (user_email.dirty || user_email.touched)">
                  <!--  <span class="validation-message" [hidden]="!user_email.hasError('pattern')">
                      Invalid Email Address<br>
                    </span>-->
                    <span class="validation-message" [hidden]="!user_email.hasError('required')">
                      Email Address is required</span>
                  </div>
                </div>
                <div class="form-group position-relative">
                  <label for="password" class="control-label sr-only">Password</label>
                  <input type="password" class="form-control" placeholder="Password"
                         #password="ngModel" minlength="4" id="password"
                         [type]="obscure ? 'text' : 'password'"
                         [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                  <div (click)="togglePassword()" class="position-absolute" style="right: 10px; top: 10px; cursor: pointer;">
                    <i class="fa" [ngClass]="obscure ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </div>
                  <div class="text-danger"  *ngIf="password.errors && (password.dirty || password.touched)">
                    <span class="validation-message" [hidden]="!password.hasError('minlength')">
                   Invalid password<br></span>
                    <span class="validation-message" [hidden]="!password.hasError('required')">
                   Password is required</span>
                  </div>
                </div>
               <!-- <div class="form-group clearfix">
                  <label class="fancy-checkbox element-left">
                    <input type="checkbox">
                    <span>Remember me</span>
                  </label>
                </div>-->
                <button type="submit" class="btn btn-primary btn-lg btn-block"
                        *ngIf="!loaders.login" [disabled]="password.errors || user_email.errors">LOGIN</button>
                <span *ngIf="loaders.login" class="btn btn-primary btn-lg btn-block">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span >
  
                <div class="bottom d-flex justify-between align-items-start mt-2 flex-column">
                  <span class="helper-text m-b-10"><a [routerLink]="['/forgot-password']">Forgot password?</a></span>
                  <span>Don't have an account? <a [routerLink]="['/agents/register']">Agent Register</a></span>
                </div>
              </form>
            </div>
            <div class="text-muted" style="text-align: center" >
              <small style="font-weight: 600;">Powered by <a class="text-muted upl" href="https://upperlink.ng/" target="_blank">Upperlink</a> </small>
            </div>
          </div>
          <div class="card-bg d-flex align-self-baseline" style="overflow: hidden;">
            <img
              style="width: 100%; height: 90vh; border-radius: 10px;"
             [src]="imagesList[cardImageIndex].src" [alt]="imagesList[cardImageIndex].alt" class="fade-effect">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
